import type { SubGameCategory } from '@repo-level/core-front';
import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMS_URL, isCMSV3 } from 'helpers/conf';
import type {
  CMSApiBase,
  CMSCountryParams,
  CMSGroupMode,
  CMSImageBase,
  CMSScheduler,
} from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface CMSGameCategory
  extends CMSApiBase,
    CMSScheduler,
    CMSCountryParams {
  categoryId: string;
  title: string;
  filterTitle?: string;
  titleH1?: string;
  description?: string;
  icon?: CMSImageBase;
  order?: number;

  groupsIncludeMode: CMSGroupMode | null;
  groupsInclude: string | null;
  groupsExcludeMode: CMSGroupMode | null;
  groupsExclude: string | null;

  durationFrom: string | null;
  durationTo: string | null;
  showOnLobby: boolean | null;

  subCategories: SubGameCategory[];
}

export const gameCategoriesV3 = factory(
  (r) => (lang: string) =>
    r<CMSGameCategory[]>('get', `${CMS_URL}/game-categories?_locale=${lang}`)
);

export const gameCategoriesV4 = factory(
  (r) => (lang: string) =>
    r<CMSGameCategory[]>(
      'get',
      buildCmsUrl({
        path: 'game-categories',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const gameCategories = isCMSV3 ? gameCategoriesV3 : gameCategoriesV4;

export interface SeparatedCategoriesSection {
  title: string;
}

export const separatedCategoriesSectionV3 = factory(
  (r) => (lang: string) =>
    r<SeparatedCategoriesSection>(
      'get',
      `${CMS_URL}/separated-categories-section?_locale=${lang}`
    )
);

export const separatedCategoriesSectionV4 = factory(
  (r) => (lang: string) =>
    r<SeparatedCategoriesSection>(
      'get',
      buildCmsUrl({ path: 'separated-categories-section', lang }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const separatedCategoriesSection = isCMSV3
  ? separatedCategoriesSectionV3
  : separatedCategoriesSectionV4;
